import { Vue, Watch } from 'vue-property-decorator'
import { DataFilters, FiltersDateFormats } from '@/types/Dashboard'
import moment from 'moment'
import LogService from '@/services/support/LogService'

export abstract class AbstractReportComponent extends Vue {
  filters: DataFilters = new DataFilters()
  loadingData = false
  filtersHead = ''
  printingReport = false
  initialPageTitle = ''

  get filtersStore (): DataFilters {
    return this.$store.state.global.reportsFilters
  }

  @Watch('$route.query')
  watchQueryParams (value: string) {
    this.filter(value)
  }

  @Watch('filtersStore')
  watchFiltersStore (value: string) {
    this.refreshFiltersInfo()
  }

  filter (query: string) {
    try {
      const params = new URLSearchParams(query)

      const filters = new DataFilters()
      filters.template = params.get('template') ? Number(params.get('template')) : 0
      filters.group = params.get('group') ? Number(params.get('group')) : 0
      filters.initDate = params.get('initDate') ? moment(params.get('initDate') as string, FiltersDateFormats.QUERY_STRING).format(FiltersDateFormats.FROM_QUERY_STRING) : ''
      filters.endDate = params.get('endDate') ? moment(params.get('endDate') as string, FiltersDateFormats.QUERY_STRING).format(FiltersDateFormats.FROM_QUERY_STRING) : ''
      this.filters = filters
      this.refreshData()

      const elem = document.querySelector('.report-view')
      if (elem) elem.scrollTop = 0
    } catch (err) {
      LogService.error(err)
    }
  }

  validateRatio () {
    if (window.devicePixelRatio < 0.75) {
      alert('El zoom del navegador es demasiado bajo para una resolución óptima del reporte. El zoom mínimo recomendado es 75%.')
    }
  }

  startPrint () {
    this.printingReport = true
    ;(document.getElementsByTagName('body')[0] as any).classList.add('print-report')
  }

  endPrint () {
    this.printingReport = false
    ;(document.getElementsByTagName('body')[0] as any).classList.remove('print-report')
  }

  abstract refreshData(): void

  abstract refreshFiltersInfo(): void
}
